var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-app-modal"},[_c('InAppPreviewLayout',{scopedSlots:_vm._u([{key:"vertical",fn:function(){return [_c('div',{staticClass:"in-app-modal-vertical"},[_c('div',{staticClass:"in-app-modal-vertical-body",style:({
                        display:
                            _vm.template.InAppProps.Image.URL &&
                            _vm.template.InAppProps.Image.URL.length
                                ? 'grid'
                                : 'block',
                    })},[_c('img',{staticClass:"in-app-modal-vertical-body__close",attrs:{"src":require("@/assets/images/inApp/modal/close.svg"),"alt":""}}),_c('span',{staticClass:"in-app-modal-vertical-body__title",style:({
                            fontSize:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            color: _vm.template.InAppProps.Styling.Title.Color,
                            height:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            lineHeight:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                        })},[_vm._v(_vm._s(_vm.template.Title || _vm.template.Subject))]),(
                            _vm.template.InAppProps.Image.URL &&
                            _vm.template.InAppProps.Image.URL.length
                        )?_c('img',{staticClass:"in-app-modal-vertical-body__image",attrs:{"src":_vm.template.InAppProps.Image.URL,"alt":""}}):_vm._e(),_c('span',{staticClass:"in-app-modal-vertical-body__text",style:({
                            fontSize:
                                +_vm.template.InAppProps.Styling.Desc.FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            color: _vm.template.InAppProps.Styling.Desc.Color,
                            height:
                                (+_vm.template.InAppProps.Styling.Desc
                                    .FontSize +
                                    1) *
                                    _vm.textSmallingCoef *
                                    3 +
                                'px',
                            lineHeight:
                                +(
                                    _vm.template.InAppProps.Styling.Desc
                                        .FontSize + 1
                                ) *
                                    _vm.textSmallingCoef +
                                'px',
                        })},[_vm._v(_vm._s(_vm.template.Template))]),_c('div',{staticClass:"in-app-modal-vertical-body__button-wrapper"}),(_vm.template.InAppProps.PrimaryButton.Title)?_c('span',{staticClass:"in-app-modal-vertical-body__button",style:({
                            color:
                                _vm.template.InAppProps.Styling
                                    .PrimaryButtonColor,
                            backgroundColor:
                                _vm.template.InAppProps.PrimaryButton
                                    .BackgroundColor,
                        }),on:{"click":function($event){return _vm.onOpenUrl(
                                _vm.template.InAppProps.PrimaryButton.ActionURL
                            )}}},[_vm._v(_vm._s(_vm.template.InAppProps.PrimaryButton.Title))]):_vm._e()])])]},proxy:true},{key:"horizontal",fn:function(){return [_c('div',{staticClass:"in-app-modal-horizontal"},[_c('img',{staticClass:"in-app-modal-horizontal__close",attrs:{"src":require("@/assets/images/inApp/modal/close.svg"),"alt":""}}),_c('div',{staticClass:"in-app-modal-horizontal-body",style:({
                        display:
                            _vm.template.InAppProps.Image.URL &&
                            _vm.template.InAppProps.Image.URL.length
                                ? 'grid'
                                : 'block',
                    })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                            _vm.template.InAppProps.Image.URL &&
                            _vm.template.InAppProps.Image.URL.length
                        ),expression:"\n                            template.InAppProps.Image.URL &&\n                            template.InAppProps.Image.URL.length\n                        "}],staticClass:"in-app-modal-horizontal-body__image",style:({
                            backgroundImage: ("url(" + (_vm.template.InAppProps.Image.URL) + ")"),
                        })}),_c('div',{staticClass:"in-app-modal-horizontal-body__right",style:({
                            textAlign:
                                _vm.template.InAppProps.Image.URL &&
                                _vm.template.InAppProps.Image.URL.length
                                    ? 'left'
                                    : 'center !important',
                        })},[_c('span',{staticClass:"in-app-modal-horizontal-body__title",style:({
                                fontSize:
                                    +_vm.template.InAppProps.Styling.Title
                                        .FontSize *
                                        _vm.textSmallingCoef +
                                    'px',
                                color:
                                    _vm.template.InAppProps.Styling.Title.Color,
                                height:
                                    +_vm.template.InAppProps.Styling.Title
                                        .FontSize *
                                        _vm.textSmallingCoef +
                                    'px',
                                lineHeight:
                                    +_vm.template.InAppProps.Styling.Title
                                        .FontSize *
                                        _vm.textSmallingCoef +
                                    'px',
                            })},[_vm._v(_vm._s(_vm.template.Title || _vm.template.Subject))]),_c('span',{staticClass:"in-app-modal-horizontal-body__text",style:({
                                fontSize:
                                    +_vm.template.InAppProps.Styling.Desc
                                        .FontSize *
                                        _vm.textSmallingCoef +
                                    'px',
                                color:
                                    _vm.template.InAppProps.Styling.Desc.Color,
                                height:
                                    (+_vm.template.InAppProps.Styling.Desc
                                        .FontSize +
                                        2) *
                                        _vm.textSmallingCoef *
                                        3 +
                                    'px',
                                lineHeight:
                                    +(
                                        _vm.template.InAppProps.Styling.Desc
                                            .FontSize + 2
                                    ) *
                                        _vm.textSmallingCoef +
                                    'px',
                            })},[_vm._v(_vm._s(_vm.template.Template))]),_c('div',{staticClass:"in-app-modal-horizontal-body__button-wrapper",style:({
                                width:
                                    _vm.template.InAppProps.Image.URL &&
                                    _vm.template.InAppProps.Image.URL.length
                                        ? '0'
                                        : null,
                            })},[(
                                    _vm.template.InAppProps.PrimaryButton.Title
                                )?_c('span',{staticClass:"in-app-modal-horizontal-body__button",style:({
                                    color:
                                        _vm.template.InAppProps.Styling
                                            .PrimaryButtonColor,
                                    backgroundColor:
                                        _vm.template.InAppProps.PrimaryButton
                                            .BackgroundColor,
                                    margin:
                                        _vm.template.InAppProps.Image.URL &&
                                        _vm.template.InAppProps.Image.URL.length
                                            ? '0 auto'
                                            : '0',
                                }),on:{"click":function($event){return _vm.onOpenUrl(
                                        _vm.template.InAppProps.PrimaryButton
                                            .ActionURL
                                    )}}},[_vm._v(_vm._s(_vm.template.InAppProps.PrimaryButton.Title))]):_vm._e()])])])])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }